export default __webpack_public_path__ + "static/media/glasses-yellow-dark.71bd2568.svg";